import React, { useEffect } from 'react'
import styles from '../../../sass/home.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import { fetchFeaturedBrands } from '../../../redux/actions/brandActions'
import { BASE_URL } from '../../../constant'
import { Link } from 'react-router-dom'
import Slider from 'react-slick'

const FeaturedBrands = () => {
    const dispatch = useDispatch();
  const { featuredBrands, loader } = useSelector(state => state.brands);

  useEffect(() => {
    dispatch(fetchFeaturedBrands());
  }, [dispatch]);

  if (loader) {
    return <div className={styles.loadingText}>Loading...</div>;
  }

  if (featuredBrands.length === 0) {
    return <div className={styles.infoText}>No featured brands available</div>;
  }

  const settings = {
    dots: false,
    speed: 500,
    draggable: true,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToScroll: 6,
            arrows: false,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToScroll: 4,
            arrows: false,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToScroll: 3,
            arrows: false,
          },
        },
    ],
  };

  return (
    <div className='section_innerWrapper'>
        <div className='section_title'>Featured Brands</div>
        <div className='section_subtitle'>Pick from our favourite brands</div>

        <div>
            {featuredBrands.length > 0 ? (
                <Slider {...settings} className={`${styles.slickSlider} fbrands_slick_slider`}>
                {featuredBrands.map((brand, index) => (
                    <div key={index} className={styles.brandItem}>
                        <Link to={`/brand/${brand.slug}`}>
                            <img src={`${BASE_URL}${brand.thumbnail}`} alt={brand.name} className={styles.brandThumbnail}/>
                        </Link>
                    </div>
                ))}
                </Slider>
            ) : (
                <div className={styles.infoText}>No featured brands available</div>
            )}
        </div>
    </div>
  )
}

export default FeaturedBrands